export default {
  name: {
    presence: {
      allowEmpty: false,
      message: "Nome é obrigatório."
    }
  }
};



// WEBPACK FOOTER //
// ./src/core/constraint/category.constraint.js